export function parseShippingMethodName(name: string) {
  // NOTE: this is specific for stock orders, to group >$500 and <$500 order type methods
  if (/fedex ground[<|>]500/gi.test(name)) {
    return 'FEDEX GROUND';
  }
  return name;
}
